import { render } from "./IoHeader.vue?vue&type=template&id=106fc6f6&ts=true"
import script from "./IoHeader.vue?vue&type=script&lang=ts"
export * from "./IoHeader.vue?vue&type=script&lang=ts"

import "./IoHeader.vue?vue&type=style&index=0&id=106fc6f6&lang=scss"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__